import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Insurance } from './models/insurance';
import { BaseService } from '../core/services/shared/base.service';

@Injectable()
export class InsuranceService {

  constructor(private baseService: BaseService) { }

  getInsurance(): Observable<Insurance[]> {
    return this.baseService.get<Insurance[]>(`InsurancePlan`);
  }
}
